import { Text, Title } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { RootPaths } from "@src/appV2/App/paths";
import { SHIFT_DISCOVERY_LIST_PATH } from "@src/appV2/redesign/ShiftDiscovery/paths";

import { Button } from "../../components/Button";
import { ShiftStatusFilter, type ShiftStatusFilterType } from "../types";

interface GuidedSupportEmptyStateProps {
  statusFilter: ShiftStatusFilterType;
}

/**
 * Empty state displayed when no shifts are available for the selected filter.
 */
export function GuidedSupportEmptyState(props: GuidedSupportEmptyStateProps) {
  const { statusFilter } = props;

  const isUpcoming = statusFilter === ShiftStatusFilter.UPCOMING;

  return (
    <Stack
      sx={(theme) => ({
        flex: 1,
        flexGrow: 1,
        alignItems: "center",
        justifyContent: "center",
        padding: theme.spacing(6),
      })}
      spacing={5}
    >
      <Title semibold variant="h4" component="h3" sx={{ textWrap: "balance", textAlign: "center" }}>
        {isUpcoming ? "No upcoming shifts" : "No past shifts"}
      </Title>
      <Text
        semibold
        textAlign="center"
        variant="body2"
        sx={(theme) => ({ paddingBottom: theme.spacing(8), textWrap: "balance" })}
      >
        {isUpcoming ? "Book a shift to see it here" : "Your past shifts will appear here"}
      </Text>
      {isUpcoming && (
        <Button variant="contained" href={`${RootPaths.APP_V2_HOME}/${SHIFT_DISCOVERY_LIST_PATH}`}>
          Browse Shifts
        </Button>
      )}
    </Stack>
  );
}
